/* eslint-disable */
import Helper from "./util/Helper";

'use strict';

const urlParams = new URLSearchParams(window.location.search);

let utmSources = (Helper.getCookie('utmSources') !== undefined || Helper.getCookie('utmSources') !== null) ? Helper.getCookie('utmSources') : null;
if (window.location.search !== '' && window.location.search.includes('utm_')) {
    utmSources = {};
    const queryParams = new URLSearchParams(window.location.search);

    queryParams.forEach(function (value, key) {
        if (key === 'portal') {
            return;
        }
        const utmKey = key.replace('_', '');
        utmSources[key] = utmKey + '_' + value;
    });
    utmSources = Object.values(utmSources).join('AND');
}

/* Start Cookie */
// set cookie for Google Analytics utmSources and fill hidden input
if ((!Helper.getCookie('utmSources') && !!utmSources) || (Helper.getCookie('utmSources') !== utmSources && !!utmSources)) {
    Helper.setCookie('utmSources', utmSources, 0, true);
}
if (!Helper.getCookie('portal') && urlParams.get('portal')) {
    Helper.setCookie('portal', urlParams.get('portal'), 30);
}
if (urlParams.has('referral')) {
    localStorage.setItem('referral', urlParams.get('referral'));
}
$(document).ready(function () {
    var referral = localStorage.getItem('referral');
    if (referral) {
        $('a[href*="rightmart.de/formular/"]').each(function () {
            var href = $(this).attr('href');
            href += (href.includes('?') ? '&' : '?') + 'referral=' + referral;
            $(this).attr('href', href);
        });
    }

    $('.fsCell').each(function () {
        if ($(this).attr('fs-field-validation-name') === 'referral') {
            $(this).find('.fsField').attr('value', referral);
        }
    });
});

window.onload = function () {
    var url = window.location.origin + window.location.pathname.replace(/\/$/, ''),
        wanted = window.location.origin + '/erfolgreich-angemeldet',
        wanted2 = window.location.origin + '/anmeldung-alert/erfolgreich-angemeldet',
        wanted3 = window.location.origin + '/update/erfolgreich-angemeldet',
        wanted4 = window.location.origin + '/woj-bestaetigung',
        allParams = {},
        params = {
            email: getUrlParam('email'),
            anrede: getUrlParam('anrede'),
            vorname: getUrlParam('vorname'),
            nachname: getUrlParam('nachname'),
            firma: getUrlParam('firma'),
        };

    if (url === wanted) {
        sendZapierHook('1900339/bi2dqqz', params);
    }
    if (url === wanted2) {
        sendZapierHook('1900339/bvkl9sl', params);
    }
    if (url === wanted3) {
        sendZapierHook('1900339/34enq2r', params);
    }
    if (url === wanted4) {
        urlParams.forEach((value, key) => {
            allParams[key] = value;
        });
        sendZapierHook('1900339/2nazu6s', allParams);
    }
    let utmSourcesValue = Helper.getCookie('utmSources')
    if (utmSourcesValue !== null && utmSourcesValue !== '') {
        utmSourcesValue = utmSourcesValue.replace(/AND/g, '&').replace(/_/g, '=').replace(/utm/g, 'utm_');
        replaceUrlParameter('?utmparameter', utmSourcesValue);
    }
};

/**
 * Replace URL parameter
 * @param parameterToReplace
 * @param newValue
 */
function replaceUrlParameter(parameterToReplace, newValue) {
    let links = document.querySelectorAll('a[href*="' + parameterToReplace + '"]');
    if (links.length) {
        for (let i = 0; i < links.length; i++) {
            let link = links[i],
                href = link.href;
            if (href.includes(parameterToReplace)) {
                // replace parameter with cookie value
                link.href = href.replace(parameterToReplace, '?' + newValue);
            }
        }
    }
}

/**
 * @param urlPart
 * @param params
 */
function sendZapierHook(urlPart, params) {
    fetch('https://hooks.zapier.com/hooks/catch/' + urlPart + '/', {
        method: 'POST',
        body: JSON.stringify(params)
    }).then(res => res.json())
        .then(res => console.log(res));
}

/**
 * @param param
 * @returns {string|string}
 */
function getUrlParam(param) {
    return urlParams.get(param) ? urlParams.get(param) : ''
}


// WEBPACK FOOTER //
// ./scripts/form-sources.js